<template>
  <div class="link-container" :class="isPc ? 'pc': 'mobile'">
    <input class="check-box" :class="isDisabled ? 'disabled': ''" :disabled="isDisabled" v-model="internalValue" type="checkbox">
    <span class="title" :class="link && 'has-link'" @click="handelLink">{{ title }}</span>
  </div>
</template>

<script>
import { deviceType } from '@/utils/common'

export default {
  props: {
    value: {
    },
    title: {
      type: String,
      default: ''
    },
    isPc: {
      type: Boolean,
      default: true
    },
    link: {
      type: String
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: ''
    }
  },
  computed: {
    isiOS () {
      return deviceType.isiOS
    }
  },
  created () {
    this.internalValue = this.value
  },
  mounted () {
  },
  methods: {
    handelLink () {
      if (this.link) {
        let link = this.link
        if (!link.startsWith('http')) {
          link = `http://${link}`
        }
        if (this.isiOS) {
          window.location.href = link
        } else {
          window.open(link)
        }
      }
    }
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.link-container {
  display: flex;
  align-items: flex-start;

  .check-box {
    margin: 0 10px 0 0;
    height: 32px;
    width: 12px;
    display: inline-block;
    flex-shrink: 0;

    &.disabled {
      cursor: not-allowed;
    }
  }

  .title {
    text-align: left;
    cursor: default;
    color: #606266;
    display: inline-block;

    &.has-link {
      cursor: pointer;
      color: #409EFF;
    }
  }

  &.pc {
    margin: auto;
    width: 35%;
    display: flex;
  }
}
</style>
